<template>
    <div class="login-body">
        <div class="login-panel p-fluid">
            <div class="login-panel-content">
                <div class="grid">
                    <div class="p-mb-5">
                        <div class="p-d-flex p-jc-center p-mb-5"><img style="max-width: 20%" src="/assets/logo-highlight-common.svg" alt="yuzaner" /></div>

                        <h3 class="p-d-flex p-jc-center p-mt-2"><span>{{ $store.state.i18n.messageBundle?.password_reset?.reset_account_password }}</span></h3>

                        <form v-if="!isRequestSuccess" @submit.prevent="onSubmit" class="p-my-5">
                            <div class="p-fluid">
                                <div class="p-my-3">                                    
                                    <div class="p-mb-2">
                                        <label for="phone" class="account-attr-font">
                                            <strong>{{ $store.state.i18n.messageBundle?.profile?.phone }}</strong>
                                        </label>
                                    </div>
                                    <Dropdown
                                        v-model="countryPhoneValue"
                                        :options="countryPhoneValues"
                                        optionLabel="name"
                                        :placeholder="$store.state.i18n.messageBundle?.contact_info?.place_holder?.country_code+' *'"
                                        :filter="true"
                                        :showClear="true"
                                        @change="updateCountryCode()"
                                        class="multiselect-custom p-mr-3"
                                    >
                                        <template #value="slotProps">
                                            <div class="country-item country-item-value" v-if="slotProps.value">
                                                <img alt="flg" src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-' + slotProps.value.code.toLowerCase()" />
                                                <div>{{ slotProps.value.name }}</div>
                                            </div>
                                            <template v-else>
                                                {{ slotProps.placeholder }}
                                            </template>
                                        </template>
                                        <template #option="slotProps">
                                            <div class="country-item">
                                                <img alt="flg" src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-' + slotProps.option.code.toLowerCase()" />
                                                <div>{{ slotProps.option.name }}</div>
                                            </div>
                                        </template>
                                    </Dropdown>
                                    <div class="phone-number-holder">
                                        <InputText style="text-align: right; max-width: 100px;" 
                                            :placeholder="$store.state.i18n.messageBundle?.contact_info?.country_code" v-model="phoneCountryCode" disabled class="p-mt-3 country-code" :class="{ 'p-invalid': v$.phone.$invalid && submitted }" />
                                        <InputText
                                            id="phone"
                                            :placeholder="$store.state.i18n.messageBundle?.contact_info?.place_holder?.phone_number+' *'"
                                            v-model="v$.phone.$model"
                                            :disabled="!phoneCountryCode || phoneCountryCode.length < 1"
                                            type="number"
                                            class="p-mt-3 phone-number-input"
                                            :class="{ 'p-invalid': v$.phone.$invalid && submitted }"
                                        />
                                    </div>
                                    <div>
                                        <small v-if="v$.phone.$invalid && submitted" class="p-error p-mt-3">
                                            {{ $store.state.i18n.messageBundle?.profile?.phone }}&nbsp;{{ $store.state.i18n.messageBundle?.common?.required_field }}
                                        </small>
                                    </div>
                                </div>

                                <div class="p-my-3">
                                    <div>
                                        <label for="resetCode" class="account-attr-font" :class="{ 'p-error': v$.resetCode.$invalid && submitted }">
                                            <strong>{{ $store.state.i18n.messageBundle?.password_reset?.reset_code }}</strong>
                                        </label>                                        
                                        <InputText id="resetCode" 
                                            :placeholder="$store.state.i18n.messageBundle?.password_reset?.place_holder?.reset_code" type="text" v-model="v$.resetCode.$model" class="p-mt-2" :class="{ 'p-invalid': v$.resetCode.$invalid && submitted }" />
                                    </div>
                                    <div>
                                        <small v-if="v$.resetCode.$invalid && submitted" class="p-error">
                                            {{ $store.state.i18n.messageBundle?.password_reset?.reset_code }}&nbsp;{{ $store.state.i18n.messageBundle?.common?.required_field }}
                                        </small>
                                    </div>
                                </div>

                                <div class="p-mb-3">
                                    <div>
                                        <label for="newPassword" class="account-attr-font" :class="{ 'p-error': v$.newPassword.$invalid && submitted }">
                                            <strong>{{ $store.state.i18n.messageBundle?.profile?.new_password }}</strong>
                                        </label>
                                        <div class="p-inputgroup p-mt-2">
                                            <InputText
                                                id="newPassword"
                                                class="password-input-text-corner"
                                                :placeholder="$store.state.i18n.messageBundle?.profile?.enter_new_password"
                                                maxLength="50"
                                                :type="newPasswordInputType"
                                                v-model="v$.newPassword.$model"
                                                :class="{ 'p-invalid': v$.newPassword.$invalid && submitted }"
                                            />
                                            <Button icon="pi pi-eye" class="input-group-button p-button-info password-input-btn-corner" :disabled="!newPassword" @click="toggleNewPasswordInputType()" />
                                        </div>
                                    </div>
                                    <div>
                                        <small v-if="v$.newPassword.$invalid && submitted" class="p-error">
                                            {{ $store.state.i18n.messageBundle?.profile?.new_password }}&nbsp;{{ $store.state.i18n.messageBundle?.common?.required_field }}
                                        </small>
                                    </div>
                                </div>

                                <div class="p-mb-3">
                                    <div>
                                        <label for="confirmPassword" class="account-attr-font" :class="{ 'p-error': v$.confirmPassword.$invalid && submitted }">
                                            <strong>{{ $store.state.i18n.messageBundle?.profile?.confirm_password }}</strong>
                                        </label>                                        
                                        <div class="p-inputgroup">
                                            <InputText
                                                id="confirmPassword"
                                                :placeholder="$store.state.i18n.messageBundle?.profile?.enter_confirm_password"
                                                maxLength="50"
                                                :type="confirmPasswordInputType"
                                                v-model="v$.confirmPassword.$model"
                                                class="password-input-text-corner"
                                                :class="{ 'p-invalid': v$.confirmPassword.$invalid && submitted }"
                                            />
                                            <Button icon="pi pi-eye" class="input-group-button p-button-info password-input-btn-corner" :disabled="!confirmPassword" @click="toggleConfirmPasswordInputType()" />
                                        </div>
                                    </div>
                                    <div>
                                        <small v-if="v$.confirmPassword.$invalid && submitted" class="p-error">
                                            {{ $store.state.i18n.messageBundle?.profile?.confirm_password }}&nbsp;{{ $store.state.i18n.messageBundle?.common?.required_field }}
                                        </small>
                                    </div>
                                </div>

                                <div class="p-my-1">
                                    <Button :disabled="isProcessing || v$.resetCode.$invalid || v$.newPassword.$invalid ||v$.confirmPassword.$invalid || v$.phone.$invalid || submitted" class="p-button-primary" @click="resetPasswordByPhone()" 
                                        :label="$store.state.i18n.messageBundle?.common?.update">
                                    </Button>
                                </div>
                                <div class="p-my-3">
                                    <InlineMessage v-if="isError && errorMsg" severity="error">{{ $store.state.i18n.messageBundle?.password_reset?.reset_code_error }}</InlineMessage>
                                </div>
                            </div>                            
                        </form>
                        <div v-else>
                            <InlineMessage severity="success">{{ $store.state.i18n.messageBundle?.password_reset?.completed }}</InlineMessage>
                            <Button class="p-button-primary" @click="gotoLoginWithPhone()" :label="$store.state.i18n.messageBundle?.auth?.useful_links?.login_with_phone"></Button>
                        </div>
                        <hr />
                        <div class="p-mt-3">
                            <h5>{{ $store.state.i18n.messageBundle?.common?.useful_links }}</h5>
                            <div class="p-mb-3">
                                <a class="p-button-link" @click="gotoReqResetCodeByPhone()">&nbsp;<span class="pi pi-check-circle"></span>&nbsp;Request New Reset Code</a>
                            </div>
                            <div class="p-mb-3">
                                <a class="p-button-link" @click="gotoLoginWithPhone()">&nbsp;<span class="pi pi-sign-in"></span>&nbsp;{{ $store.state.i18n.messageBundle?.auth?.useful_links?.login_with_phone }}</a>
                            </div>                           
                        </div>
                        <div style="padding-bottom: 50px"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import AuthService from '../service/AuthService';
import UtilService from '../service/UtilService';
export default {
    authService: null,
    utilService: null,
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            phone: null,
            phoneCountryCode: null,
            countryPhoneValue: null,
            countryPhoneValues: [
                { name: 'Australia', code: 'AU', phoneCountryCode: '+61' },
                //{name: 'China', code: 'CN', phoneCountryCode: '+86'},
                //{name: 'India', code: 'IN', phoneCountryCode: '+91'},
                { name: 'Indonesia ', code: 'ID', phoneCountryCode: '+62' },
                { name: 'Malaysia', code: 'MY', phoneCountryCode: '+60' },
                { name: 'Myanmar', code: 'MM', phoneCountryCode: '+95' },
                { name: 'Philippine', code: 'PH', phoneCountryCode: '+63' },
                { name: 'Singapore', code: 'SG', phoneCountryCode: '+65' },
                { name: 'Thailand', code: 'TH', phoneCountryCode: '+66' },
                //{name: 'Vietnam', code: 'VN', phoneCountryCode: '+84'},
            ],
            resetCode: '',
            newPasswordInputType: 'password',
            showNewPasswordFlag: false,
            confirmPasswordInputType: 'password',
            showConfirmPasswordFlag: false,
            newPassword: null,
            confirmPassword: null,
            submitted: false,            
            isProcessing: false,
            isError: false,
            isRequestSuccess: false,
            errorMsg: '',
        };
    },
    created() {
        this.$store.dispatch('createTitle', process.env.VUE_APP_QUOTE);
        this.authService = new AuthService();
        this.utilService = new UtilService();

        let user = this.$loadUserData(this);
        if (user) {
            this.$gotoProfile(this);
        }
    },
    validations() {
        return {
            phone: {
                required,
            },
            phoneCountrycode: {
                required,
            },
            resetCode: {
                required,
            },
            newPassword: {
                required,
            },
            confirmPassword: {
                required,
            },
        };
    },
    methods: {
        async resetPasswordByPhone() {
            try {
                this.isProcessing = true;
                this.isError = false;
                this.submitted = true;
                let payload = {
                    countryCode: this.countryPhoneValue.phoneCountryCode,
                    phoneNumber: this.phone,
                    resetCode: this.resetCode,
                    newPassword: this.newPassword,
                    confirmPassword: this.confirmPassword,
                };
                let response = await this.authService.resetPasswordByPhone(payload);
                this.utilService.consoleLog('response:', response);
                this.isRequestSuccess = true;
            } catch (err) {
                let errObject = this.utilService.defineError(err);
                this.utilService.consoleLog('errObject:', errObject);
                if (errObject.errorDescription) {
                    this.errorMsg = errObject.errorDescription;
                } else {
                    this.errorMsg = 'Error occurred while processing request! Please try again later.';
                }
                this.isError = true;
                this.isRequestSuccess = false;
            } finally {
                this.isProcessing = false;
                this.submitted = false;
            }
        },
        resetForm() {
            this.email = '';
            this.password = '';
        },
        
        updateCountryCode() {
            if (this.countryPhoneValue) {
                this.phoneCountryCode = this.countryPhoneValue.phoneCountryCode;
            } else {
                this.phoneCountryCode = null;
                this.phone = null;
            }
        },
        togglePasswordInputType() {
            if (this.showPasswordFlag) {
                this.showPasswordFlag = false;
                this.passwordInputType = 'password';
            } else {
                this.showPasswordFlag = true;
                this.passwordInputType = 'text';
            }
        },
        toggleNewPasswordInputType() {            
            if (this.showNewPasswordFlag) {
                this.showNewPasswordFlag = false;
                this.newPasswordInputType = 'password';
            } else {
                this.showNewPasswordFlag = true;
                this.newPasswordInputType = 'text';
            }
        },
        toggleConfirmPasswordInputType() {            
            if (this.showConfirmPasswordFlag) {
                this.showConfirmPasswordFlag = false;
                this.confirmPasswordInputType = 'password';
            } else {
                this.showConfirmPasswordFlag = true;
                this.confirmPasswordInputType = 'text';
            }
        },
        gotoLoginWithPhone(){
            this.$gotoLoginWithPhone(this);
        },
        gotoShop() {
            this.$gotoShop(this);
        },
        gotoRegistry() {
            this.$gotoAccountRegistry(this);
        },
        gotoReqResetCodeByPhone() {
            this.$router.push({ path: '/request-reset-password-with-phone' });
        },
    },
};
</script>

<style lang="scss" scoped>
.password-input-text-corner {
    border-radius: 3px 0 0 3px !important;
    border-width: 1px 0 1px 1px !important;
}

.password-input-btn-corner {
    border-radius: 0 3px 3px 0;
    border-width: 1px 1px 1px 0;
    border-color: #65656a;
}

.login-body {
    overflow: hidden;
    position: relative;
    background: url('https://stc-content.ackaya.com/_exp_content/yuzaner/common/images/digital-bg1.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 150vh;
    padding: 0;
    margin: 0;
}

.login-holder {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
a {
    cursor: pointer;
}
a:hover {
    text-decoration: none;
}

.input-group-button {
    margin-top: 0em !important;
    display: block;
    min-width: auto !important;
}

.country-item {
    display: flex;
    align-items: center;
}
.country-item img.flag {
    width: 18px;
    margin-right: 0.5rem;
}

.multiselect-custom .country-placeholder {
    padding: 0.25rem;
}
::v-deep(.p-chips .p-chips-token) {
    background-color: var(--primary-color);
    color: var(--primary-color-text);
}
::v-deep(.p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-token) {
    margin: 0.1rem 0.5rem 0.1rem 0;
}

.p-dropdown {
    width: 100%;
    font-weight: normal;
}

.phone-number-holder {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.country-code {
    width: 25%;
    margin-right: 2px;
}

.phone-number-input {
    width: 75%;
}

.login-body .login-panel {
    background-color: rgba(255, 255, 255, 0.9);
    opacity: 0.95;
}

@media screen and (max-width: 40em) {
    .login-body {
        height: 180vh;
    }

    .login-body .login-panel {
        background-color: rgba(255, 255, 255, 0.9);
        opacity: 0.95;
        height: 100%;
    }
}
</style>
